import React from "react";
import Button from "@mui/material/Button";
import PropTypes from "prop-types";

function borderButton (props) {
    const handleButtonClick = () => {
        props.btnClick();
    };

    return (
        <Button
            variant="outlined"
            className="borderButton"
            onClick={handleButtonClick}
            fullWidth={props.showFullWidth}
        >
            {props.btnName}
        </Button>
    );
};

export default borderButton;
borderButton.propTypes = {
    btnName: PropTypes.string.isRequired,
    btnClick: PropTypes.func.isRequired,
    showFullWidth: PropTypes.bool,
    endBtnIcon: PropTypes.element,
};

borderButton.defaultProps = {
    showFullWidth: false,
    endBtnIcon: null,
};
